import * as _ from 'lodash';
import * as React from 'react';

import {
    InputLabel,
    InputLabelProps,
    InputProps as StandardInputProps,
    TextField as MTextField,
    Theme,
} from '@mui/material';
import { PropsWithChildren } from 'react';
import { SxProps } from '@mui/system';

export interface NumberFieldProps extends PropsWithChildren {
    readonly id?: string;
    readonly margin?: 'dense';
    readonly key?: string;
    readonly className?: string;
    readonly label?: string;
    readonly value?: number;
    readonly placeholder?: string;
    readonly required?: boolean;
    readonly readOnly?: boolean;
    readonly disabled?: boolean;
    readonly multiline?: boolean;
    readonly rows?: number;
    readonly error?: boolean;
    readonly select?: boolean;
    readonly fullWidth?: boolean;
    readonly InputProps?: Partial<StandardInputProps>;
    readonly InputLabelProps?: Partial<InputLabelProps>;
    readonly defaultValue?: unknown;
    readonly variant?: 'standard' | 'outlined' | 'filled';
    readonly color?: 'primary' | 'secondary';
    readonly onChange?: (val: number) => void;
    readonly sx?: SxProps<Theme>;
}

export class NumberField extends React.PureComponent<NumberFieldProps> {
    render() {
        const { label, value, variant, color, children, margin } = this.props;
        return (
            <>
                {label && label !== '' && (
                    <InputLabel>{label}</InputLabel>
                )}
                <MTextField
                    {..._.pick(
                        this.props,
                        'id',
                        'key',
                        'className',
                        'placeholder',
                        'required',
                        'disabled',
                        'multiline',
                        'rows',
                        'error',
                        'select',
                        'fullWidth',
                        'InputLabelProps',
                        'defaultValue',
                        'InputProps',
                        'readOnly',
                        'sx',
                    )}
                    value={value || 0}
                    onChange={this.onChange}
                    margin={margin || 'none'}
                    color={color || 'primary'}
                    variant={variant || 'standard'}
                    type={'number'}
                >
                    {children}
                </MTextField>
            </>
        );
    }

    private onChange = (eventObject: any) => {
        let val = eventObject.target.value;
        const { value, onChange } = this.props;
        if (typeof value !== 'number') {
            return;
        }
        val = +val;
        if (isNaN(val)) {
            return;
        }
        if (onChange) {
            onChange(val);
        }
    };
}
